import { postStream, postStreamEvent } from '@/lib/api';

import type { AnalyticsPlugin } from '../types';

export const createVialmaPlugin = (): AnalyticsPlugin => ({
  name: 'vialma',

  track: (event, context) => {
    if (!context.siteId || !context.tenantId) return;

    switch (event.type) {
      case 'custom':
        return;

      case 'stream_init': {
        const payload = {
          stream_id: event.streamId,
          created_at: Date.now(),
          content_played: event.contentPlayed,
          content_parent: event.contentParent,
          stream_context: event.context,
        };

        postStream(
          context.siteId,
          context.tenantId,
          JSON.stringify(payload),
        ).catch(() => {});
        return;
      }

      case 'stream_marker': {
        const payload = {
          stream_id: event.streamId,
          type: event.markerType,
          timer: {
            start: Math.round(event.timer.start),
            end: Math.round(event.timer.end),
          },
          cumulative_time: event.cumulativeTime,
          rendition: event.rendition,
          created_at: Date.now(),
        };

        postStreamEvent(
          context.siteId,
          context.tenantId,
          event.streamId,
          JSON.stringify(payload),
        ).catch(() => {});
      }
    }
  },
});
